import type { Dict } from './index';

// Portekizce (Brezilya) sözlük — Claude tarafından elle çevrildi (06.08.2026),
// makine çevirisi kullanılmadı. en.ts ile aynı yapıda olmalı (tip zorunlu kılar).
export const ptBR: Dict = {
  map: {
    title: "Localizações compartilhadas",
    hint: "Somente localizações ativas compartilhadas explicitamente com você. O último ponto pode não ser atual.",
    empty: "Nenhuma localização ativa compartilhada com você.",
    waiting: "Aguardando um ponto de localização.",
    error: "Não foi possível verificar as localizações. Tente novamente.",
    providerError: "Não foi possível carregar o mapa. A lista continua disponível.",
    fit: "Mostrar todas",
    lastPoint: "Última localização: {time}",
    unknown: "Pessoa sem nome",
  },
  visit: {
    title: "Convite para visita",
    incoming: "Esta pessoa convida você para uma visita.",
    hint: "Convite revogável do anfitrião, só para esta pessoa. Não compartilha sua localização nem representa uma reserva ou a aceitação dela.",
    place: "Local",
    time: "Horário",
    defaultPlace: "Minha localização",
    defaultTime: "A qualquer momento",
    enabled: "Esta pessoa está convidada para uma visita.",
    off: "Você não tem um convite aberto para esta pessoa.",
    edit: "Editar local e horário",
    save: "Salvar e ativar convite",
    revoke: "Retirar convite",
    unavailable: "Convite indisponível. É preciso ter uma conversa; verifique novamente.",
  },
  signInMethods: {
    // D-871 — the linked Google accounts, and removing one.
    googleAccountUnknown: "Conta do Google (endereço ainda desconhecido)",
    googleLinkedDate: "Vinculada em {date}",
    googleRemove: "Remover",
    googleRemoveTitle: "Remover esta conta do Google?",
    googleRemoveBody: "Primeiro você vai confirmar seu número cadastrado. Depois disso, esta conta do Google não poderá mais entrar no nosubject.",
    googleRemoveConfirm: "Digite o código para remover {account}.",
    googleRemoved: "Conta do Google removida.",
    googleLastMethod: "Esta é a única forma de entrar nesta conta, por isso não pode ser removida.",
    googleAddAnother: "Vincular outra conta do Google",
    googleLinkedCount: "Contas do Google vinculadas: {count}",
    googleLinked: "Conta do Google vinculada.",
    googleCodeSent: "Enviamos um código para seu número cadastrado com final {phone}.",
    googleChooseHint: "A conta do Google escolhida será vinculada para entrar nesta conta do nosubject.",
    googleStatusUnknown: "Não foi possível verificar a conexão com o Google. Tente verificar novamente.",
    googleLinkIntro: "Verifique o telefone cadastrado nesta conta antes de vincular o Google.",
    googleLinkFailed: "Não foi possível concluir a solicitação. Tente novamente.",
    googleSendCode: "Enviar código de verificação",
    googleCodeLabel: "Código de verificação",
    googleStartAgain: "Recomeçar",
    googleContinue: "Continuar com o Google",
    googleFailed: "Não foi possível concluir o login com o Google. Tente novamente.",
    googleNotLinked: "Esta conta do Google ainda não está vinculada a uma conta do nosubject.",
    googleUnavailable: "O login com o Google ainda não está disponível.",
    title: "Métodos de login",
    intro: "Esta seção está em preparação. As opções para gerenciar os métodos de login serão adicionadas depois.",
    identity: "Verificação de identidade",
    identityInfo: "Verificar sua identidade é um processo separado do login na sua conta.",
  },
  safety: {
    title: 'Número de segurança',
    compare: 'Compare este número com {name}. Se for igual, ninguém no meio do caminho consegue ler as mensagens de vocês.',
    explainInfo: 'O número é calculado a partir das chaves de criptografia de todos os dispositivos atuais de vocês dois e aparece igual nos dois celulares. Se um de vocês adicionar um dispositivo, como um celular novo ou a web, o número muda; aí comparem de novo. A verificação fica salva só neste dispositivo.',
    qrLabel: 'Código QR do número de segurança',
    verified: 'Verificado',
    notVerified: 'Não verificado',
    markVerified: 'Marcar como verificado',
    clearVerified: 'Remover verificação',
    peerUnavailable: 'A criptografia com esta pessoa ainda não está ativa.',
    selfUnavailable: 'A chave de criptografia deste dispositivo ainda não está pronta.',
    loadFailed: 'Não foi possível carregar o número de segurança.',
  },
  backup: {
    title: 'Backup da conversa',
    explainInfo: 'Seu histórico fica neste aparelho. O backup o criptografa com seu código de recuperação e o guarda no servidor; não conseguimos abrir.',
    create: 'Criar backup',
    refresh: 'Atualizar backup',
    codeTitle: 'Seu código de recuperação',
    codeWarning: 'Guarde este código em lugar seguro. Se perder, seu histórico não volta, e nem nós conseguimos abrir.',
    restoreTitle: 'Restaurar histórico',
    restorePlaceholder: 'Código de recuperação',
    restore: 'Restaurar',
    restored: '{count} mensagens restauradas.',
    restoreFailed: 'Não foi possível abrir o histórico. Confira o código.',
    failed: 'Não foi possível criar o backup.',
  },
  common: {
    clear: "Limpar busca",
    infoHide: 'Ocultar explicação: {subject}',
    infoShow: 'Mostrar explicação: {subject}',
    continue: 'Continuar',
    cancel: 'Cancelar',
    close: 'Fechar',
    save: 'Salvar',
    done: 'Concluído',
    retry: 'Tentar novamente',
    error: 'Erro',
    back: 'Voltar',
    search: 'Buscar…',
    loading: 'Carregando',
    remove: 'Remover',
    offline: 'Não foi possível acessar o servidor. Verifique sua conexão.',
    sessionExpired: 'Sua sessão terminou. Entre novamente.',
    tooManyRequests: 'Muitas solicitações. Espere um pouco e tente de novo.',
  },
  time: {
    now: 'agora',
    minAgo: 'há {n} min',
    hourAgo: 'há {n} h',
    yesterday: 'ontem',
    dayAgo: 'há {n} dias',
    weekAgo: 'há {n} semanas',
    weekAgoOne: 'há {n} semana',
    today: 'Hoje',
    dayYesterday: 'Ontem',
  },
  phone: {
    sendFailed: "Não foi possível enviar o código. Tente novamente.",
    subtitle: 'Digite seu número de telefone',
    selectCountry: 'País / região',
    countrySearch: 'Buscar país…',
    architectureLink: 'Arquitetura técnica e plano de evolução ↗',

  },
  otp: {
    verifyFailed: "Não foi possível verificar o código. Tente novamente.",
    invalidCode: "O código é inválido ou expirou.",
    rateLimited: "Muitas tentativas. Tente novamente mais tarde.",
    title: 'Digite o código',
    sentTo: 'Enviamos um SMS para {phone}',
    verify: 'Verificar',
    resend: 'Reenviar',

    tooManyAttempts: 'Muitas tentativas. Espere um pouco e tente de novo.',

    resendSent: 'Um novo código foi enviado.',
    resendFailed: 'Não foi possível enviar o código. Verifique sua conexão e tente de novo.',
    resendWait: 'Você pode pedir de novo em {n} s',
  },
  university: {
    title: 'Qual é a sua universidade?',
    subtitle: 'Busque sua universidade',
    placeholder: 'Harvard, Oxford…',
    skip: 'Pular',
  },
  profession: {
    title: 'O que você faz?',
    subtitle: 'Busque sua profissão',
    placeholder: 'Professor, desenvolvedor, enfermeiro…',
    skip: 'Pular',
  },
  isco: {
    '0': 'Forças armadas',
    '1': 'Diretores e gerentes',
    '2': 'Profissionais das ciências e intelectuais',
    '3': 'Técnicos e profissionais de nível médio',
    '4': 'Trabalhadores de apoio administrativo',
    '5': 'Trabalhadores dos serviços e vendedores',
    '6': 'Trabalhadores agropecuários, florestais e da pesca',
    '7': 'Trabalhadores qualificados, operários e artesãos',
    '8': 'Operadores de instalações e máquinas',
    '9': 'Ocupações elementares',
  },
  isced: {
    '5': 'Tecnólogo',
    '6': 'Graduação',
    '7': 'Mestrado',
    '8': 'Doutorado',
  },
  profileCreate: {
    photoPickerFailed: "Não foi possível abrir a biblioteca de fotos.",
    title: 'Crie seu perfil',
    addPhoto: 'Adicionar foto',
    name: 'Seu nome',
    surname: 'Seu sobrenome',
  },
  terms: {
    title: 'Antes de começar',
    age: 'Tenho mais de 18 anos',
    accept: 'Li e aceito os Termos de Serviço e a Política de Privacidade',
    termsLink: 'Termos de Serviço',
    privacyLink: 'Política de Privacidade',
    continue: 'Aceitar e continuar',
    saveFailed: 'Não foi possível salvar seu consentimento. Verifique sua conexão e tente de novo.',
    docPlaceholder: 'Este documento será publicado em breve.',
  },
  locationConsent: {
    title: 'Sua localização, somente se você quiser',
    body: 'Precisamos da permissão de localização para sugerir o distrito e a cidade quando você tirar uma foto.',
    privacy: 'Esta etapa não acessa sua localização. Ela só é usada após uma foto ser tirada com sucesso, e suas coordenadas exatas não são armazenadas. Você pode alterar a permissão depois nos ajustes do dispositivo.',
    allow: 'Permitir localização',
    later: 'Agora não',
  },
  discover: {
    title: "Descobrir",
    categories: "Categorias profissionais",
    categoryHint: "Explore pessoas pelas profissões compartilhadas nos perfis.",
    all: "Todas",
    reset: "Limpar filtros",
    failed: 'Não foi possível carregar',
    free: 'Grátis',
    empty: 'Ainda não há ninguém aqui',
  },
  userProfile: {
    smsVerifiedOn: "Telefone verificado por SMS · {date}",
    googleLinkedOn: "Conta Google vinculada · {date}",
    contactProofNote: "Confirma o acesso ao telefone ou à conta Google, não a identidade da pessoa.",
    failed: 'Não foi possível carregar o perfil',
    sendMessage: 'Enviar mensagem',
    buyTime: 'Propor um encontro',
    block: 'Bloquear',
    blockedNotice: '{name} está bloqueado. Mensagens, chamadas e encontros desativados.',
    blockTitle: 'Bloquear {name}?',
    blockMessage: 'Essa pessoa não poderá te enviar mensagens nem te encontrar na aba Descobrir.',
    blockConfirm: 'Bloquear',
  },
  callHistory: {
    empty: 'Ainda não há chamadas',
    tabAll: 'Todas',
    tabMissed: 'Perdidas',
    emptyMissed: 'Nenhuma chamada perdida',
    failed: 'Não foi possível carregar as chamadas',
    outgoing: 'Efetuada',
    incoming: 'Recebida',
    missed: 'Perdida',
    declined: 'Recusada',
    cancelled: 'Cancelada',
  },
  call: {
    title: 'Chamada de voz',
    calling: 'Chamando…',
    incoming: 'Chamada recebida',
    connecting: 'Conectando…',
    connected: 'Conectado',
    reconnecting: 'Reconectando…',
    logAnswered: 'Chamada de voz',
    logAnsweredVideo: 'Chamada de vídeo',
    logNoAnswer: 'Sem resposta',
    logMissed: 'Chamada perdida',
    logDeclined: 'Chamada recusada',
    logYouDeclined: 'Você recusou a chamada',
    logCancelled: 'Chamada cancelada',
    ended: 'Chamada encerrada',
    accept: 'Atender',
    decline: 'Recusar',
    hangUp: 'Desligar',
    close: 'Fechar',
    mute: 'Desativar microfone',
    unmute: 'Ativar microfone',
    cameraOff: 'Desligar câmera',
    cameraOn: 'Ligar câmera',
    flipCamera: 'Trocar câmera',
    audioOutput: 'Saída de áudio: {route}',
    audioOutputTitle: 'Escolha a saída de áudio',
    earpiece: 'Auricular',
    speaker: 'Viva-voz',
    bluetooth: 'Bluetooth',
    bluetoothPermissionDenied: 'A permissão de Bluetooth está desativada. Ative nos Ajustes.',
    micPermission: 'As chamadas precisam de acesso ao microfone. Ative nos Ajustes.',
    micPermissionWeb: 'As chamadas precisam de acesso ao microfone. Permita nas configurações do site do seu navegador.',
    wiredHeadset: 'Fone com fio',
    audioRouteFailed: 'Não foi possível alterar a saída de áudio',
    acceptFailed: 'Não foi possível atender à chamada. Tente novamente.',
    declineFailed: 'Não foi possível recusar a chamada. Tente novamente.',
    endFailed: 'Não foi possível encerrar a chamada. Tente novamente.',
    mediaConnectionFailed: 'Não foi possível estabelecer a conexão de áudio. A chamada terminou sem cobrança.',
    remaining: '{time} restante',
    endingSoon: 'Esta chamada terminará em breve.',
    spent: '{amount} gasto',
    earned: '{amount} ganho',
    noAudioNotice: 'Esta versão ainda não transmite áudio. O fluxo da chamada e a cobrança estão em teste.',
    failed: 'Não foi possível iniciar a chamada',
    insufficient: 'Seu saldo não é suficiente para esta chamada',
    busy: 'A pessoa está em outra chamada',
    notAllowed: 'É preciso haver pelo menos uma mensagem entre você e esta pessoa antes de ligar',
    notAccepting: 'Esta pessoa não está aceitando chamadas agora',
    priceFree: 'Grátis',
    priceChanged: 'A tarifa da chamada mudou. Veja a nova tarifa e tente de novo.',
    rateLimited: 'Você fez muitas tentativas de chamada. Aguarde um pouco e tente novamente.',
    reservationLinkUnavailable: 'Esta reserva não pode mais ser vinculada à chamada. Você pode iniciar uma chamada comum em vez disso.',
    missed: 'Chamada perdida',
    callNow: 'Ligar agora',
    videoNow: 'Chamada de vídeo agora',
    scheduledStartTitle: 'Chamada agendada',
    scheduledStartBody: 'Sua chamada agendada com {name} está começando. Ligar agora?',
    schedule: 'Agendar uma chamada',
    scheduleTitle: 'Agendar uma chamada com {name}',
    subjectPlaceholder: 'Assunto (opcional)',
    priceNote: 'Tarifa da chamada: {price}',
    sendReservation: 'Enviar pedido de reserva',
    reservationSent: 'Pedido enviado',
    reservationSentBody: 'Seu pedido de reserva de chamada foi enviado para {name}.',
    reservationFailed: 'Não foi possível enviar o pedido de reserva da chamada',
    reservationBubble: '☎️ Reserva de chamada solicitada',
    reservationBubbleShort: '☎️ Reserva de chamada',
    reservationLabel: 'Reserva de chamada de voz',
    rescheduleBubble: '☎️ Novo horário de chamada proposto',
    rescheduleBubbleShort: '☎️ Novo horário de chamada',
  },
  wallet: {
    otherAmount: "Outro",
    customAmount: "Valor",
    customAmountHint: "Até {amount}; no máximo duas casas decimais.",
    title: 'Carteira',
    failed: 'Não foi possível carregar a carteira',
    availableBalance: 'Saldo disponível',
    earningsTitle: 'Meus ganhos',
    earningsTotal: 'Total ganho',
    earningsWithdrawable: 'Disponível para saque',
    earningsEscrow: 'Em garantia',
    addFunds: 'Adicionar saldo',
    addFundsDemo: 'Demo: adicione saldo de teste à sua conta',
    addFundsFailed: 'Não foi possível adicionar saldo.',
    topupLabel: 'Saldo adicionado',
    transactions: 'Transações',
    noTransactions: 'Ainda não há transações',
    waiting: 'pendente',
    incomingRequest: 'pedido recebido',
    replied: 'respondido',
    earned: 'recebido',
    refunded: 'Reembolsado',
    requestPayout: 'Sacar',
    payoutHint: 'Você pode sacar até {amount}.',
    payoutAll: 'Selecionar o valor total',
    payoutRequested: 'Solicitação recebida',
    payoutRequestedBody: 'Uma solicitação de saque de {amount} foi criada e será processada em breve.',
    payoutFailed: 'Não foi possível criar a solicitação de saque',
    payoutRequests: 'Solicitações de saque',
    noPayouts: 'Ainda não há solicitações de saque',
    payoutStatusPending: 'Pendente',
    payoutStatusPaid: 'Pago',
    payoutStatusRejected: 'Rejeitado',
    paymentAccount: 'Conta de pagamento',
    stripeConnect: 'Conectar conta de pagamento',
    stripeConnectInfo: 'Vincule sua conta bancária para receber seus ganhos (Stripe, modo de teste)',
    stripeConnected: 'Conectada',
    stripeConnectFailed: 'Não foi possível conectar',
  },
  calendar: {
    dateInputLabel: "Data",
    timeInputLabel: "Hora",
    dateInputHint: "Digite o ano, o mês e o dia no formato YYYY-MM-DD.",
    timeInputHint: "Digite a hora no formato de 24 horas: HH:MM.",

    previousWeek: 'Semana anterior',
    nextWeek: 'Próxima semana',
    empty: 'Nenhuma solicitação para mostrar',
    failed: 'Não foi possível carregar o calendário',
    statusPending: 'Pendente',
    statusAccepted: 'Aceito',
    statusDeclined: 'Recusado',
    statusCancelled: 'Cancelado',
    statusExpired: 'Expirado',
    accept: 'Aceitar',
    decline: 'Recusar',
    cancel: 'Cancelar',
    cancelConfirmationTitle: 'Cancelar esta reserva?',
    cancelConfirmationAcceptedBody: 'A reserva confirmada com {name} será cancelada. A outra pessoa será avisada e não será possível desfazer esta ação.',
    cancelConfirmationPendingBody: 'A proposta enviada para {name} será retirada. A outra pessoa será avisada e não será possível desfazer esta ação.',
    actionFailed: 'A ação falhou',
    proposeTitle: 'Propor um encontro com {name}',
    locationPlaceholder: 'Onde? (opcional)',
    sendProposal: 'Enviar proposta',
    proposalSent: 'Proposta enviada',
    proposalSentBody: 'Sua proposta de encontro foi enviada para {name}.',
    priceChangedBody: 'A tarifa por minuto desta reserva agora é {amount}. Nenhuma proposta foi criada — confira a nova tarifa e envie uma nova proposta.',
    proposalFailed: 'Não foi possível enviar a proposta',
    meetupBubble: '📅 Encontro proposto',
    meetupBubbleShort: '📅 Proposta de encontro',
    proposeAction: '📅 Propor um encontro',
    priceNote: 'Tarifa do encontro: {price}',
    totalCost: 'Total: {amount}',
    minutesShort: 'min',
    tabRequests: 'Solicitações',
    tabCalendar: 'Calendário',
    tabActive: 'Atuais',
    tabHistory: 'Histórico',
    loadMore: 'Ver mais',
    noEventsForDay: 'Nenhum evento neste dia',
    meetupLabel: 'Encontro presencial',
    reservationDetails: 'Detalhes da reserva',
    reservationParticipant: 'Pessoa',
    reservationHeld: 'A chamada aconteceu',
    reservationNotHeld: 'Nenhuma chamada foi feita',
    reservationDateTime: 'Data e hora',
    reservationDuration: 'Duração',
    reservationRate: 'Por minuto',
    reservationLocation: 'Local',
    reservationSubject: 'Assunto',

    reservationQuotedTotal: 'Total proposto',
    reservationBilledDuration: 'Duração cobrada',
    reservationSpentAmount: 'Valor pago',
    reservationEarnedAmount: 'Valor recebido',
    reservationSettledAt: 'Liquidado em',
    reservationCreated: 'Criada em',
    reservationResponded: 'Respondida em',
    reservationAcceptedAt: 'Aceita em',
    reservationDeclinedAt: 'Recusada em',
    reservationCancelledAt: 'Cancelada em',
    reservationCancelledBy: 'Cancelada por',
    reservationYou: 'Você',
    reservationCancellationNotification: 'Envio da notificação',
    reservationNotificationPending: 'Preparando',
    reservationNotificationProviderAccepted: 'Aceita pelo provedor de envio',
    reservationNotificationSuppressed: 'Não enviada devido às preferências de notificação',
    reservationNotificationUnavailable: 'Nenhum dispositivo qualificado foi encontrado',
    reservationPendingReschedule: 'Novo horário proposto',
    reservationNewTime: 'Nova data e hora',
    proposeNewTime: 'Propor novo horário',
    rescheduleFuture: 'O novo horário deve estar no futuro e ter pelo menos um minuto de diferença do horário de início agendado atualmente.',
    reservationCallTooEarly: 'Esta chamada agendada ficará disponível 15 minutos antes do início.',
    reservationCallExpired: 'A janela de chamada desta reserva terminou.',
    reservationCallInProgress: 'A chamada vinculada a esta reserva já foi iniciada.',
    reservationExecutionLocked: 'Esta chamada agendada não pode mais ser alterada porque já começou ou terminou.',
    openReservation: 'Abrir detalhes da reserva com {name}',
    systemEventMeetupTitle: 'Encontro com {name}',
    systemEventCallTitle: 'Chamada agendada com {name}',
    systemEventNotes: 'Aceito por meio do nosubject.',
    systemCalendarCopyRemoved: 'A cópia do calendário do sistema foi excluída',
    restoreSystemCalendarCopy: 'Restaurar',
    systemCalendarRestoreFailed: 'Não foi possível restaurar a cópia do calendário. Verifique as conexões e a permissão do sistema.',
    systemCalendarCopyChanged: 'O horário do calendário do sistema foi alterado',
    reviewSystemCalendarChange: 'Revisar',
    systemCalendarChangeTitle: 'Horário do calendário alterado',
    systemCalendarChangeBody: 'Esta alteração não foi aplicada à outra pessoa.\n\nnosubject: {nosubject}\nCalendário do sistema: {system}',
    restoreNosubjectTime: 'Restaurar horário do nosubject',
    systemCalendarTimeRestoreFailed: 'Não foi possível corrigir o horário da cópia. Verifique as conexões e a permissão do sistema.',
    proposeReschedule: 'Propor à outra pessoa',
    rescheduleSent: 'Novo horário proposto',
    rescheduleSentBody: 'Seu novo horário foi enviado para {name}. O horário atual permanece até a aceitação.',
    rescheduleFailed: 'Não foi possível propor o novo horário.',
    rescheduleActionFailed: 'Não foi possível atualizar a proposta de horário.',
    reschedulePendingReceived: 'Proposta de novo horário: {time}',
    reschedulePendingSent: 'Novo horário aguardando resposta: {time}',
    withdrawReschedule: 'Retirar proposta',
    rescheduleBubble: '📅 Novo horário de encontro proposto',
    rescheduleBubbleShort: '📅 Novo horário de encontro',
    connectionsTitle: 'Conexões de calendário',
    connectionsInfo: 'Escolha os calendários que deseja ver',
    deviceCalendar: 'Calendários do dispositivo',
    connect: 'Conectar',
    openSettings: 'Abrir ajustes',
    permissionGranted: 'Acesso concedido',
    permissionDenied: 'Acesso desativado',
    permissionUnavailable: 'Indisponível nesta versão',
    permissionNotRequested: 'Ainda não conectado',
    devicePermissionInfo: 'A permissão só é solicitada quando você toca neste botão. O nosubject lê apenas os calendários selecionados e o período necessário; não grava eventos nesta tela.',
    selectCalendars: 'Calendários exibidos',
    noDeviceCalendars: 'Não há calendários de eventos disponíveis neste dispositivo.',
    manageSystemPermission: 'Gerenciar permissão do calendário',
    connectionPrivacyInfo: 'A seleção fica neste dispositivo para esta conta. Os detalhes externos serão usados apenas na sua visualização e não serão compartilhados automaticamente.',
    newBuildRequired: 'Uma versão mais recente é necessária para conectar calendários.',
    connectionFailed: 'Não foi possível conectar o calendário.',
    disconnect: 'Desconectar',
    disconnectTitle: 'Desconectar o calendário?',
    disconnectBody: 'O nosubject deixará de ler calendários e de gravar novos eventos aceitos neste dispositivo. As seleções e os vínculos locais serão apagados; os eventos existentes no calendário do sistema permanecerão. A permissão do sistema pode ser revogada separadamente nos ajustes do dispositivo.',
    disconnectFailed: 'Não foi possível desconectar o calendário.',
    selectionSaveFailed: 'Não foi possível salvar a seleção.',
    allDay: 'Dia inteiro',
    recurring: 'Recorrente',
    availabilityFree: 'Livre',
    availabilityBusy: 'Ocupado',
    availabilityTentative: 'Provisório',
    availabilityUnavailable: 'Indisponível',
    untitledExternalEvent: 'Evento sem título',
    externalEventsFailed: 'Não foi possível carregar os eventos externos.',
    hideExternalEvent: 'Ocultar {title} desta visualização',
    hideExternalEventFailed: 'Não foi possível ocultar o evento.',
    restoreHiddenExternalEvents: 'Mostrar novamente os eventos ocultos',
    restoreHiddenExternalEventsFailed: 'Não foi possível mostrar novamente os eventos ocultos.',
    hiddenExternalEventCount: '{count} eventos ocultos neste dispositivo',
    checkIncompleteTitle: 'Verificação do calendário incompleta',
    checkIncompleteBody: 'Não foi possível ler temporariamente pelo menos uma fonte de calendário. Por isso, não podemos confirmar que este horário esteja totalmente livre. Você ainda pode continuar.',
    conflictCheckIncomplete: 'Alguns calendários não puderam ser lidos, então pode haver outros conflitos.',
    conflictTitle: 'Conflito de calendário',
    reservationUnavailable: 'Este horário não está mais disponível devido a outra reserva confirmada.',
    reservationChanged: 'Esta reserva foi alterada em outra tela ou dispositivo. Carregamos a versão mais recente.',
    reservationPast: 'Uma reserva cujo horário de início já passou não pode ser aceita.',
    conflictBody: 'Este horário coincide com outro evento do seu calendário. Você ainda pode continuar.',
    tentativeConflictTitle: 'Evento provisório no calendário',
    tentativeConflictBody: 'Há um evento do calendário ainda não confirmado neste horário. Confira os detalhes antes de continuar.',
    conflictMore: '• Outros eventos: {count}',
    continueAnyway: 'Continuar mesmo assim',
    onlineCalendars: 'Calendários on-line',
    googleCalendar: 'Google Agenda',
    providerConnected: 'Conectado',
    providerNotConnected: 'Não conectado',
    providerUnavailable: 'A conexão oficial está sendo preparada',
    googlePrivacyInfo: 'Somente os calendários que você escolher serão sincronizados. Títulos e locais ficam criptografados em um cache mínimo do servidor; descrições, participantes e links de conferência não são armazenados. O nosubject não pode criar, alterar nem excluir eventos do Google Agenda.',
    googleConnectionFailed: 'Não foi possível iniciar a conexão com o Google Agenda.',
    microsoftCalendar: 'Calendário da Microsoft',
    microsoftInfo: 'O nosubject só lê sua disponibilidade (Calendars.Read). Não pode criar, alterar nem excluir eventos. O acesso é removido nas configurações da sua conta Microsoft; o nosubject não pode revogá-lo sozinho.',
    microsoftConnectionFailed: 'Não foi possível iniciar a conexão com o calendário da Microsoft.',
    googleDisconnectTitle: 'Desconectar o Google Agenda?',
    googleDisconnectBody: 'O nosubject deixará de acessar os dados do Google Agenda e revogará as permissões do Google que você concedeu ao nosubject. Os eventos do Google Agenda não serão excluídos.',
    googleDisconnectFailed: 'Não foi possível desconectar o Google Agenda.',
    googleNoCalendars: 'Nenhum calendário do Google legível foi encontrado.',
    googleSelectionSaveFailed: 'Não foi possível salvar a seleção do Google Agenda.',
  },
  instagram: {
    title: 'Conexão com o Instagram',
    connectInfo: 'Conecte sua conta profissional com consentimento explícito',
    connectedAccounts: 'Contas conectadas',
    professionalAccount: 'Conta profissional',
    connect: 'Conectar',
    reconnect: 'Reconectar',
    connectedAs: '@{username} · {accountType}',
    notConnected: 'Ainda não conectada',
    unavailable: 'A conexão oficial está sendo preparada',
    privacyInfo: 'A primeira etapa solicita apenas instagram_business_basic para ler a identidade da conta profissional. Não solicita permissões de mensagens, comentários ou publicação e não copia fotos para o nosubject até que você escolha importá-las separadamente.',
    business: 'Empresa',
    creator: 'Criador',
    connectionFailed: 'Não foi possível iniciar a conexão com o Instagram.',
  },
  inbox: {
    markUnread: 'Marcar como não lida',
    markRead: 'Marcar como lida',
    archiveTitle: 'Arquivo',
    archive: 'Arquivo',
    failed: 'Não foi possível carregar as conversas',
    searchEmpty: 'Nenhum resultado',
    archivedEmpty: 'Nenhuma conversa arquivada',
    empty: 'Ainda não há conversas',
    you: 'Você:',
    archived: 'Arquivada',
    unarchived: 'Desarquivada',
    undo: 'Desfazer',
    mute: 'Silenciar',
    muteTitle: 'Silenciar {name}',
    mute1h: 'Por 1 hora',
    mute8h: 'Por 8 horas',
    mute1w: 'Por 1 semana',
    muteForever: 'Por tempo indeterminado',
    unmute: 'Reativar notificações',
    archiveAction: 'Arquivar',
    unarchiveAction: 'Desarquivar',
    swipeRemove: 'Desarquivar',
    swipeArchive: 'Arquivar',
    blockAction: 'Bloquear',
    blockTitle: 'Bloquear {name}?',
    blockMessage: 'Essa pessoa não poderá te enviar mensagens nem te encontrar na aba Descobrir.',
    blockConfirm: 'Bloquear',
  },
  // 9.33.9.3 / D-780 — passkeys, named as the system names them.
  passkeys: {
    // D-882 — signing in with a passkey.
    signIn: "Entrar com chave-senha",
    signInIntro: "Com uma chave-senha, você entra sem número de telefone nem código.",
    signInNone: "Este dispositivo não tem chave-senha para o nosubject. Entre primeiro com seu número e depois adicione uma em Perfil → Configurações → Métodos de login → Chaves-senha.",
    signInFailed: "Não foi possível entrar com sua chave-senha. Tente novamente.",
    // D-876 — a lost passkey, reset after a 48-hour wait.
    lost: "Perdeu sua chave-senha?",
    recoveryIntro: "Se nenhum dos seus dispositivos tem mais sua chave-senha, você pode redefini-la. Depois de confirmar seu número, é preciso esperar 48 horas. Avisamos você no seu chat, e quem tiver sua chave-senha pode cancelar a redefinição.",
    recoveryPending: "A redefinição ficará pronta em {date}.",
    recoveryCancel: "Cancelar redefinição",
    recoveryCancelled: "Redefinição cancelada.",
    recoveryReady: "A redefinição está pronta. Adicione sua nova chave-senha.",
    recoveryDone: "Sua nova chave-senha foi adicionada. As antigas não funcionam mais.",
    title: "Chaves-senha",
    intro: "Uma chave-senha confirma que é você do mesmo jeito que você desbloqueia este dispositivo. Ela fica no seu dispositivo; o nosubject nunca recebe seu rosto nem sua digital.",
    taskIntro: "As mensagens que você envia para a conta oficial do nosubject são confirmadas com uma chave-senha antes de serem enviadas.",
    empty: "Você ainda não tem uma chave-senha.",
    add: "Adicionar chave-senha",
    remove: "Remover",
    removeTitle: "Remover esta chave-senha?",
    removeBody: "Primeiro você vai confirmar com uma chave-senha.",
    added: "Chave-senha adicionada.",
    removed: "Chave-senha removida.",
    addedOn: "Adicionada em {date}",
    lastUsed: "Último uso em {date}",
    unnamed: "Chave-senha",
    reauthIntro: "Para adicionar sua primeira chave-senha, confirme seu número de telefone cadastrado.",
    sendCode: "Enviar código de verificação",
    codeSent: "Enviamos um código para seu número cadastrado com final {phone}.",
    codeLabel: "Código de verificação",
    startAgain: "Recomeçar",
    wrongCode: "Esse código não funcionou. Peça um novo.",
    failed: "Não foi possível concluir a solicitação. Tente novamente.",
    exists: "Este dispositivo já tem uma chave-senha para sua conta.",
    unsupportedApp: "Esta versão do app ainda não pode usar chaves-senha. Elas chegam com a próxima atualização.",
    unsupportedWeb: "Este navegador não pode usar chaves-senha.",
    tapTitle: "Continuar com sua chave-senha",
    tapAction: "Continuar",
  },
  message: {
    jumpLatest: 'Ir para a mensagem mais recente',
    info: "Informações da mensagem",
    infoSentAt: "Enviado",
    infoReadAt: "Lido",
    infoPlatform: "Enviado de",
    // 9.33.9.4 — a message to the task chat stopped for its passkey.
    passkeyNeededTitle: "Adicione uma chave-senha primeiro",
    passkeyNeededBody: "Mensagens para esta conta são confirmadas com uma chave-senha. Adicione uma e envie de novo.",
    passkeyUnavailable: "Esta mensagem precisa da sua chave-senha, que esta versão do app ainda não pode usar. Envie pelo nosubject.co ou depois da próxima atualização.",
    passkeyFailed: "Não foi possível confirmar a mensagem, então ela não foi enviada.",
    forwardOwn: "Encaminhar",
    forwardHint: "Escolha uma conversa. O texto abre como rascunho; o envio e a confirmação do preço atual são feitos depois.",
    forwardMediaHint: "Escolha uma conversa. Um rascunho de mídia separado será aberto; confira o preço e toque em Enviar. A legenda e a localização não são copiadas.",
    forwardMediaWaiting: "A preparação ainda não foi confirmada. Tentar novamente verifica a mesma operação; não envia uma mensagem.",
    forwardMediaUnavailable: "Não foi possível confirmar a operação. Confira a conversa antes de enviar novamente.",
    forwardEmpty: "Não há outras conversas ativas.",
    forwardDraftFirst: "Envie ou limpe o rascunho atual primeiro.",
    translationLanguage: "Idioma de tradução",
    chooseTranslationLanguage: "Escolha um idioma de tradução",
    languageSuggestion: "Sugestão do idioma do dispositivo",
    translationLanguageInfo: "Esta preferência privada se aplica às traduções de todas as suas conversas. Ela não é adicionada ao seu perfil.",
    photoCaption: "Adicione uma legenda à foto…",
    removePhoto: "Remover foto",
    star: "Favoritar mensagem",
    unstar: "Remover dos favoritos",
    starred: "Mensagens favoritas",
    noStars: "Não há mensagens favoritas nesta conversa.",
    starFailed: "Não foi possível atualizar os favoritos. Tente novamente.",
    starredAttachment: "Mensagem com anexo",
    edit: "Editar mensagem",
    edited: "Editada",
    editInfo: "Você pode editar até a mensagem ser lida, mesmo com as confirmações desativadas. A opção Editar desaparecer pode revelar a leitura. Não lida não significa não vista: o texto original pode ter aparecido numa notificação. Editar não garante retirar o que foi dito.",
    editFailed: "Não foi possível confirmar a edição. A mensagem pode ter sido lida ou alterada. Confira a conversa antes de tentar novamente.",
    copy: "Copiar",
    copyFailed: "Não foi possível copiar a mensagem. Tente novamente.",
    inputPlaceholder: 'Digite uma mensagem…',
    typing: 'Digitando',
    translate: 'Traduzir',
    withdrawn: 'Mensagem retirada',
    linkOpenTitle: 'Abrir link',
    linkOpenBody: 'Isto leva você para {host}. O link foi enviado por quem está te mandando mensagem — tenha cuidado se não conhece a pessoa.',
    linkOpenConfirm: 'Abrir',
    linkOpenFailed: 'Não foi possível abrir o link.',
    seenAt: 'Visto {time}',

    priceChangedTitle: 'O preço mudou',
    priceChangedBody: 'Esta mensagem agora custa {new}, não {old}. Enviar mesmo assim?',
    priceChangedSend: 'Enviar',
    priceNoticeTitle: 'Quanto custa falar com esta pessoa',
    priceNoticeMessage: '{amount} por mensagem',
    priceNoticeCall: 'Chamadas {amount}',
    priceNoticePersonal: 'Estas tarifas foram definidas especialmente para você.',
    priceDecreasedTitle: "O preço das mensagens diminuiu",
    priceDecreasedBody: "As mensagens agora custam {new} em vez de {old}. Não é necessário aprovar o preço menor.",
    priceChange: {
      free: 'grátis',
    },
    expired: 'expirada, reembolsada',
    // 9.2 / D-650 — web'den gönderilen mesajın saat satırındaki notu.
    sentFromWeb: 'pela web',
    linkViewLabel: 'Exibição do link',
    linkViewPlain: 'Endereço simples',
    linkViewCompact: 'Compacto',
    linkViewCard: 'Cartão grande',
    linkPreviewLoading: 'Preparando a prévia…',
    linkPreviewFailed: 'Não foi possível gerar a prévia deste link; ele será enviado como endereço simples.',
    linkPreviewA11y: 'Link: {title}, {host}',
    customPrice: 'Preço personalizado',
    priceUsesGeneral: 'Meu preço geral se aplica',
    priceRemove: 'Remover dos contatos',
    priceRemoveTitle: 'Remover {name} dos seus contatos?',
    priceRemoveBody: 'O preço personalizado é removido e {name} volta ao seu preço geral. Se só seus contatos podem te enviar mensagens, essa pessoa não poderá mais iniciar uma conversa. Isto não é um bloqueio.',
    priceRemoveConfirm: 'Remover',
    priceRemoved: '{name} voltou ao seu preço geral.',
    pricePrompt: 'Preços para {name} (0 = grátis):',
    saved: 'Salvo',
    priceFreeSet: '{name} agora pode te enviar mensagens de graça.',
    priceSet: 'Preço para {name} definido em {price}.',
    saveError: 'Não foi possível salvar.',
    photoError: 'Não foi possível enviar a foto.',
    noConnection: 'Sem conexão',
    checkInternet: 'Verifique sua conexão com a internet.',
    sendError: 'Não foi possível enviar a mensagem.',
    addAttachment: 'Adicionar anexo',
    sendMessageAction: 'Enviar mensagem',
    lowBalanceTitle: 'Saldo insuficiente',
    lowBalanceBody: 'Seu saldo não é suficiente para enviar uma mensagem a essa pessoa. Adicione saldo e tente novamente.',
    reply: 'Responder',
    reactionA11y: 'Reação {emoji}, {count} no total',
    reactionA11yMine: 'Reação {emoji}, {count} no total, incluindo a sua',
    reactionAdd: 'Reagir com {emoji}',
    moreReactions: 'Mais emojis',
    reactionRemove: 'Remover sua reação {emoji}',
    you: 'Você',
    photo: '📷 Foto',
    takePhoto: 'Tirar uma foto',
    choosePhoto: 'Escolher da galeria',
    chooseVideo: 'Escolher um vídeo',
    recordVoice: 'Mensagem de voz',
    micPermissionTitle: 'Acesso ao microfone necessário',
    micPermissionBody: 'Gravar uma mensagem de voz requer acesso ao microfone.',
    voiceError: 'Não foi possível enviar a mensagem de voz',
    voiceRecording: 'Gravando',
    videoTooLarge: 'O vídeo é muito grande (máximo 1 GB)',
    videoTooLong: 'O vídeo é muito longo (máximo 10 minutos)',
    videoError: 'Não foi possível enviar o vídeo',
    videoNeedsUpdate: 'Atualize o app para assistir a este vídeo',
    voiceNeedsUpdate: 'Atualize o app para ouvir esta mensagem de voz',
    voiceOrderTitle: 'Mensagem de voz encomendada',
    encrypted: 'Mensagem criptografada',
    identityChanged: 'A chave de segurança desta pessoa mudou. Normalmente significa um novo telefone ou um app reinstalado.',
    identityChangedVerify: 'Você tinha verificado esta conversa; compare o número de segurança de novo.',
    unencrypted: 'Esta conversa não é criptografada',
    unencryptedPeerInfo: 'O app da outra pessoa ainda não oferece criptografia de ponta a ponta, então o que você escreve aqui é enviado sem criptografia e pode ser lido no servidor da nosubject. Quando ela atualizar o app, as novas mensagens serão criptografadas automaticamente.',
    unencryptedOfficialInfo: 'Esta é a conta oficial da nosubject. O que você escreve aqui é enviado sem criptografia e pode ser lido pela equipe da nosubject.',
    unencryptedSelfInfo: 'Não foi possível ativar a criptografia neste dispositivo (por exemplo, uma janela anônima do navegador não guarda chaves). O que você envia daqui vai sem criptografia e pode ser lido no servidor da nosubject.',
    notificationOfferEnable: 'Ativar notificações',
    notificationOfferEnabled: 'As notificações estão ativadas',
    voiceOrderPending: 'Aguardando a entrega',
    voiceOrderDelivered: 'Entregue',
    voiceOrderDeclined: 'Recusada, reembolsada',
    voiceOrderExpired: 'Expirada, reembolsada',
    voiceOrderAction: 'Encomendar um áudio',
    voiceOrderPick: 'De quanto tempo?',
    voiceOrderInsufficient: 'Seu saldo não dá para esta encomenda.',
    voiceOrderError: 'Não foi possível fazer a encomenda.',
    voiceOrderRecord: 'Gravar e enviar',
    voiceOrderDecline: 'Recusar',
    voiceOrderDeclineTitle: 'Recusar a encomenda',
    voiceOrderDeclineBody: 'Todo o valor reservado volta para quem encomendou.',
    voiceOrderDeclineError: 'Não foi possível recusar a encomenda.',
    voiceOrderDeliverError: 'Não foi possível entregar a gravação.',
    voiceOrderRecording: 'Gravação encomendada',
    voiceOrderRemaining: 'Faltam {length}',
    voiceOrderShortNote: 'Se enviar mais curto, só o que você gravar é pago.',
    voiceOrderRefunded: '{amount} devolvido',
    sendLocation: 'Enviar localização',
    locationTitle: 'Localização',
    locationError: 'Não foi possível enviar a localização',
    shareLiveLocation: 'Compartilhar localização ao vivo',
    liveLocationHour: '1 hora',
    liveLocationEightHours: '8 horas',
    liveLocationOpenEnded: 'Até eu parar',
    liveLocationSharing: 'Compartilhando sua localização ao vivo',
    liveLocationStop: 'Parar',
    liveLocationError: 'Não foi possível iniciar a localização ao vivo',
    liveLocationCardTitle: 'Localização ao vivo',
    liveLocationCardActive: 'Compartilhando agora',
    liveLocationCardEnded: 'Compartilhamento encerrado',
    liveLocationOpen: 'Ver localização',
    liveLocationNoPoint: 'Ainda sem posição',
    liveLocationOpenInMaps: 'Abrir no Mapas',
    locationMapError: 'Não foi possível abrir o mapa.',
    liveLocationUpdatedAgo: 'Atualizado {ago}',
    videoShort: '🎬 Vídeo',
    voiceShort: '🎙 Mensagem de voz',
    liveLocationWatchedAgo: 'Visto há {ago}',
    liveLocationNotWatched: 'Ainda não foi visto',
    liveLocationSharerSeesYou: 'Ela vê quando você olha',
    cameraPermissionTitle: 'Acesso à câmera necessário',
    cameraPermissionBody: 'Permita o acesso à câmera para tirar uma foto.',
    cameraError: 'Não foi possível abrir a câmera.',
    photoLocationTitle: 'Local da foto',
    photoLocationPromptFile: '{place} foi obtido do arquivo da foto. Mostrar este local com a foto?',
    photoLocationPromptCapture: 'A localização do dispositivo indicou {place}. Mostrar este local com a foto?',
    photoLocationHide: 'Enviar sem local',
    photoLocationShare: 'Enviar com local',
    photoLocationFromFile: 'Obtido do arquivo',
    photoLocationFromCapture: 'Localização do dispositivo',
    photoLocationHideAfter: 'Ocultar local',
    photoLocationShowAfter: 'Mostrar local',
    photoLocationUpdateError: 'Não foi possível atualizar o local da foto.',
  },
  versionNotice: {
    title: 'Há uma versão nova',
    body: 'Atualize o app para ter melhorias de segurança e recursos novos.',
    update: 'Atualizar',
  },
  notifications: {
    title: 'Notificações',
    cardBody: 'Ative as notificações do dispositivo para não perder novas mensagens e respostas.',
    notNow: 'Agora não',
    enable: 'Ativar notificações',
    device: 'Notificações do dispositivo',
    stateOn: 'Ativadas · Gerenciar nos ajustes',
    stateOff: 'Desativadas · Ativar nos ajustes',
    stateAsk: 'Ainda não solicitado',
    preferences: 'Preferências de notificação',
    preferencesInfo: 'Gerencie categorias, prévias e permissão do dispositivo',
    stateUnsupported: 'Não compatível com este dispositivo',
    master: 'Todas as notificações',
    masterInfo: 'Ao desativar esta opção, você deixa de receber todas as notificações push. As configurações das categorias são mantidas',
    categories: 'Categorias',
    categoryEnabled: 'Notificações desta categoria',
    categoryEnabledInfo: 'Ao desativar esta opção, você deixa de receber notificações push desta categoria. As configurações dela são mantidas',
    events: 'Eventos',
    messages: 'Mensagens',
    messagesInfo: 'Novas mensagens e respostas',
    meetups: 'Encontros',
    meetupsInfo: 'Propostas, alterações e resultados',
    meetupRequests: 'Novas propostas de encontro',
    meetupRequestsInfo: 'Quando alguém envia uma nova proposta de encontro',
    meetupUpdates: 'Respostas e cancelamentos',
    meetupUpdatesInfo: 'Quando um encontro é aceito, recusado ou cancelado',
    meetupReminders: 'Lembretes de encontros',
    meetupRemindersInfo: 'Quando um encontro aceito está próximo',
    calls: 'Chamadas',
    callsInfo: 'Chamadas recebidas, agendadas e perdidas',
    incomingCalls: 'Chamadas recebidas',
    incomingCallsInfo: 'Um alerta sonoro quando alguém ligar para você',
    callRequests: 'Propostas de chamada agendada',
    callRequestsInfo: 'Quando uma proposta é criada, aceita, recusada ou cancelada',
    callReminders: 'Lembretes de chamadas',
    callRemindersInfo: 'Quando uma chamada aceita está próxima',
    missedCalls: 'Chamadas perdidas',
    missedCallsInfo: 'Quando você não conseguiu atender uma chamada',
    financial: 'Dinheiro e valores em garantia',
    financialInfo: 'Mudanças de status das transações',
    financialEarnings: 'Ganhos e valores em garantia',
    financialEarningsInfo: 'Quando um valor em garantia é liberado ou há ganhos disponíveis',
    financialRefunds: 'Reembolsos e vencimento',
    financialRefundsInfo: 'Quando um pagamento é reembolsado ou um valor em garantia vence',
    financialPayouts: 'Resultados de saques',
    financialPayoutsInfo: 'Quando uma solicitação de saque é concluída ou falha',
    reactions: 'Reações de emoji',
    reactionsInfo: 'Reações às suas mensagens',
    official: 'Do Nosubject',
    officialInfo: 'Avisos do Nosubject sobre versões, segurança e sua conta. Independe das suas outras notificações; se você desativar, o Nosubject não envia notificações, mas as mensagens continuam chegando à sua caixa de entrada.',
    preview: 'Prévia da mensagem',
    previewHidden: 'Oculta',
    previewHiddenInfo: 'Não mostrar remetente nem mensagem',
    previewSender: 'Somente remetente',
    previewSenderInfo: 'Mostrar remetente e ocultar mensagem',
    previewText: 'Remetente e mensagem',
    previewTextInfo: 'Mostrar até 80 caracteres',
    deviceInfo: 'A permissão do sistema é específica deste dispositivo',
    openSettings: 'Abrir ajustes',
    centerTitle: 'Central de notificações',
    centerMarkAll: 'Marcar tudo como lido', centerMarkedAll: 'Tudo marcado como lido',
    centerEmpty: 'Ainda não há notificações.',
    centerFailed: 'Não foi possível carregar as notificações.',
    centerMarkAllFailed: 'Não foi possível marcar as notificações como lidas.',
    centerUnknownPerson: 'Alguém',
    centerEscrowExpiredRefunded: 'O valor em garantia venceu · pagamento reembolsado',
    centerEscrowReleasedEarning: 'Resposta concluída · ganhos adicionados',
    centerMeetupRequest: '{name} enviou uma proposta de encontro',
    centerCallRequest: '{name} enviou uma proposta de chamada agendada',
    centerCallReminder: 'Sua chamada agendada com {name} começará em breve',
    centerCallStarting: 'Sua chamada agendada com {name} está começando',
    centerMeetupStarting: 'Seu encontro com {name} está começando',
    centerMeetupReminder: 'Seu encontro com {name} começará em breve',
    centerMeetupUpdate: '{name} · Encontro: {status}',
    centerCallUpdate: '{name} · Agendamento da chamada: {status}',
    centerMeetupRescheduleRequest: '{name} propôs um novo horário de encontro',
    centerCallRescheduleRequest: '{name} propôs um novo horário de chamada',
    centerMeetupRescheduleUpdate: '{name} · Novo horário de encontro: {status}',
    centerCallRescheduleUpdate: '{name} · Novo horário de chamada: {status}',
    centerBell: 'Central de notificações',
    centerBellUnread: 'Central de notificações, não lidas: {count}',
  },
  profile: {
    viewPhoto: "Ver foto de perfil",
    photoUnavailable: "Não foi possível carregar esta foto.",
    // 9.35.3 · D-830 — profile photos and videos.
    photos: "Fotos",
    mediaPhotoLabel: "Foto {n} de {total}",
    mediaVideoLabel: "Vídeo {n} de {total}",
    mediaUnavailable: "Não foi possível carregar as fotos",
    mediaMore: "Mostrar mais",
    // 9.35.4 · D-830 — removing one's own photo or video.
    mediaRemove: "Remover do perfil",
    mediaRemovePhotoTitle: "Remover esta foto do seu perfil?",
    mediaRemoveVideoTitle: "Remover este vídeo do seu perfil?",
    mediaRemoveBody: "O arquivo é apagado e não pode ser recuperado.",
    mediaRemoveFailed: "Não foi possível remover. Tente de novo.",
    webVisibility: 'Quem pode ver minha página na web',
    webVisibilityLink: 'Com o link',
    webVisibilityInfo: 'Seu perfil como pessoas sem conta o veem: sua página em nosubject.co/seu-usuario. Todos: sua página também pode aparecer em buscadores. Com o link: quem tiver o endereço pode abri-la; os buscadores não a listam. Nos dois casos, pessoas sem conta podem acessar os dados do seu perfil, incluindo seu visto por último. Ninguém: ninguém sem conta pode ver seu perfil; a página diz “Este perfil não está disponível”. Seu perfil no app não muda. Sair dos resultados de busca pode levar alguns dias.',
    linkViewInfo: 'Escolha como um link que você digita é enviado. Em Compacto e Cartão grande, seu telefone abre a página uma vez e envia a prévia com a mensagem; esse site vê o endereço IP do seu telefone. Em uma conversa criptografada, a prévia vai dentro da criptografia; em uma conversa sem criptografia, a nosubject vê o link e a prévia. Endereço simples não abre nenhuma página. Links enviados pela web sempre vão como endereço simples.',
    linkViewAsk: 'Mostrar opções ao digitar',
    linkViewAskInfo: 'Se estiver ativado, ao digitar um link aparecem as outras duas exibições e você pode escolher uma para essa mensagem. Se estiver desativado, os links sempre vão na exibição que você escolher aqui.',
    whoCanCallInfo: 'Escolha quem pode ligar para você; vale para todas as chamadas. Meus contatos são as pessoas para quem você definiu um preço pessoal. Em Exceções, você pode permitir ou bloquear pessoas uma a uma.',
    whoCanMessageInfo: 'Escolha quem pode iniciar uma nova conversa com você; conversas já iniciadas não mudam. Meus contatos são as pessoas para quem você definiu um preço pessoal. Em Exceções, você pode permitir ou bloquear pessoas uma a uma.',
    readReceiptsInfo: "As confirmações aparecem apenas quando ambos as ativam. Mesmo desativadas, o desaparecimento de Editar pode revelar a leitura.",
    showTypingInfo: 'Se estiver ativado, a pessoa para quem você escreve vê que você está digitando. Se desativar, ninguém vê, e você continua vendo quando os outros estão digitando.',
    officialAccount: 'Conta oficial',
    information: 'Informações do perfil',
    logout: 'Sair',
    account: 'Conta',
    accountData: 'Conta e dados',
    name: 'Nome',
    surname: 'Sobrenome',
    username: 'Nome de usuário',
    usernamePlaceholder: 'nomedeusuario',
    usernameChecking: 'Verificando…',
    usernameAvailable: 'Disponível',
    usernameTaken: 'Esse nome de usuário já está em uso',
    usernameInvalid: 'De 3 a 20 caracteres. Comece com A–Z ou a–z; depois, use A–Z, a–z, 0–9 ou _.',
    usernameAdd: 'Adicionar um nome de usuário',
    profession: 'Profissão',
    professionNone: 'Nenhuma profissão adicionada',
    professionAdd: 'Adicionar profissão',
    employer: 'Empresa',
    employerPlaceholder: 'usuariodaempresa',
    employerInfo: 'Informe um nome de usuário existente no nosubject. Essa menção não significa que o vínculo de trabalho foi verificado.',
    employerNotFound: 'Nenhuma conta ativa foi encontrada com esse nome de usuário.',
    employerSelf: 'Você não pode indicar a própria conta como empresa.',
    bio: 'Fale sobre você…',
    prices: 'Preços',
    settings: 'Configurações',
    priceMessage: 'Mensagem',
    priceVoice: 'Áudio (por minuto)',
    priceVoiceShort: 'Áudio',
    priceCall: 'Ligar agora (por minuto)',
    priceCallShort: 'Ligar agora',
    priceScheduledCall: 'Agendar chamada (por minuto)',
    priceScheduledCallShort: 'Agendar chamada',
    priceVideoCall: 'Chamada de vídeo',
    priceVideoCallShort: 'Vídeo',
    priceTime: 'Encontro (por minuto)',
    priceTimeShort: 'Encontro',
    currency: 'Moeda',
    saving: 'Salvando…',
    wallet: 'Carteira',
    chatBackup: 'Backup da conversa',
    privacy: 'Privacidade',
    readReceipts: 'Confirmações de leitura',
    showTyping: 'Indicador de digitação',
    keepArchived: 'Manter arquivada',
    keepArchivedInfo: 'Se desativado, uma nova mensagem desarquiva a conversa',
    whoCanMessage: 'Quem pode me enviar mensagens',
    whoCanCall: 'Quem pode me ligar',
    messagesFromContact: 'Mensagens desta pessoa',
    callsFromContact: 'Chamadas desta pessoa',
    callExceptions: 'Exceções',
    callExceptionsEmpty: 'Ainda não há exceções',
    messageExceptionsEmpty: 'Ainda não há exceções para mensagens',
    exceptionsLoadFailed: 'Não foi possível carregar as exceções',
    openProfileHint: 'Abre o perfil desta pessoa',
    callExceptionBlocked: 'Bloqueado',
    callsFromContactDefault: 'Padrão',
    callsFromContactAllow: 'Sempre permitir',
    callsFromContactBlock: 'Nunca',
    everyone: 'Todos',
    contacts: 'Meus contatos',
    nobody: 'Ninguém',
    blockedUsers: 'Usuários bloqueados',
    blockedEmpty: 'Você não bloqueou ninguém',
    unblock: 'Desbloquear',
    appearance: 'Aparência',
    light: 'Claro',
    dark: 'Escuro',
    system: 'Sistema',
    displayLanguage: 'Idioma do aplicativo',
    education: 'Universidade',
    educationAdd: 'Adicionar universidade',
    educationNone: 'Nenhuma universidade adicionada',

    educationLevel: 'Nível de formação',
    searchLanguage: 'Buscar idioma…',
    photoChange: 'Alterar',
    saveFailed: 'Não foi possível salvar.',
    photoFailed: 'Não foi possível enviar a foto.',
    photoChanged: "A foto mudou em outra operação ou o prazo para tentar novamente expirou. Selecione a foto novamente.",
    deleteAccount: 'Excluir conta',
    deleteTitle: 'Excluir sua conta',
    deleteMessage: 'Sua conta será excluída permanentemente após 30 dias. Você pode entrar novamente nesse período para cancelar.',
    deleteMoneyWarning: 'Você tem {amount} somando a carteira e os valores em garantia. Recomendamos sacar antes de excluir a conta.',
    deleteConfirm: 'Excluir',
    deleteFailed: 'Não foi possível excluir a conta.',
    deletionScheduled: 'Sua conta será excluída em {date}.',
    deletionCancel: 'Cancelar exclusão',
    exportData: 'Baixar meus dados',
    exportFailed: 'Não foi possível obter os dados.',
  },
  // Alt bar (dock) — ekran okuyucu etiketleri ve rozet sayıları (9.26.7.2.1)
  dock: {
    calls: 'Chamadas',
    discover: 'Descobrir',
    inbox: 'Mensagens',
    calendar: 'Calendário',
    profile: 'Perfil',
    unreadMessages: 'não lidas: {count}',
    pendingRequests: 'pendentes: {count}',
  },
  // 9.18.10.4 · D-830 — importing one's own Instagram download.
  instagramImport: {
    title: "Importar do Instagram",
    addEntry: "Importar do Instagram",
    guideIntro: "Baixe seus próprios dados do Instagram e escolha o arquivo aqui para adicionar suas fotos e vídeos ao perfil.",
    guideStep1: "No Instagram, vá em Central de Contas → Suas informações e permissões → Baixar suas informações.",
    guideStep2: "Em “Algumas das suas informações”, escolha só Conteúdo; formato JSON, qualidade de mídia Alta.",
    guideStep3: "Quando a Meta preparar o arquivo, baixe e escolha aqui.",
    guideOwnOnly: "Só aparecem fotos e vídeos que você publicou; mídia de mensagens nunca é usada.",
    guideOnDevice: "O arquivo é aberto no seu dispositivo e não vai para o nosso servidor; só o que você escolher é enviado.",
    choose: "Escolher o arquivo ZIP",
    reading: "Lendo o arquivo",
    notZip: "Este arquivo não é um ZIP.",
    untrusted: "Este arquivo não parece seguro e não foi aberto.",
    tooBig: "Este arquivo é grande demais.",
    unreadable: "Não foi possível ler este arquivo.",
    chooseAnother: "Escolher outro arquivo",
    noMedia: "Nenhuma foto ou vídeo que possa ser adicionado foi encontrado neste arquivo.",
    found: "{count} fotos e vídeos encontrados",
    slotsLeft: "Restam {count} lugares no seu perfil",
    selectAll: "Selecionar tudo",
    selectNone: "Limpar seleção",
    alreadyOnProfile: "No perfil",
    tooLarge: "Grande demais",
    add: "Adicionar {count}",
    adding: "Adicionando {n} de {total}",
    stop: "Parar",
    stopping: "Vai parar depois deste",
    doneAdded: "{count} adicionados",
    doneDuplicate: "{count} já estavam no seu perfil",
    doneSkipped: "{count} ignorados",
    doneFailed: "{count} não puderam ser adicionados",
    retryFailed: "Tentar os outros de novo",
    profileFull: "Seu perfil está cheio; não foi possível adicionar mais.",
    guideParts: "Se a Meta dividiu seu download em várias partes ZIP, escolha todas juntas.",
    catAll: "Tudo",
    catPosts: "Publicações",
    catReels: "Reels",
    catStories: "Stories",
    catIgtv: "IGTV",
    catArchived: "Arquivadas",
    catProfile: "Fotos do perfil",
    catOther: "Outros",
    archiveSection: "Download do Instagram",
    archiveHint: "Adiciona ao seu perfil as fotos e os vídeos do seu próprio download de dados.",
  },
};
